if (!customElements.get('image-text-usp-video')) {
  customElements.define(
    'image-text-usp-video',
    class ImageTextUspVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('.image-text-usp__video-toggle');
        if (!this.video || !this.button) return;

        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (this.video.paused) this.video.play();
        });

        if (!this.video.controls) {
          this.video.addEventListener('click', (event) => {
            if (event.target !== this.video) return;
            if (!this.video.paused) this.video.pause();
          });
        }

        this.video.addEventListener('play', () => this.updateToggle());
        this.video.addEventListener('pause', () => this.updateToggle());

        this.updateToggle();
      }

      updateToggle() {
        const paused = this.video.paused;
        this.button.classList.toggle('is-hidden', !paused);
        this.button.setAttribute('aria-hidden', paused ? 'false' : 'true');
      }
    }
  );
}
